// NOTE: we can hook into the datasets here to inject
// any global configs into the datasets.
export const buildChartjsDataProp = (datasets) => {
  return {
    datasets
  }
}
